(() => {
  if (window.yubzWishlistReady) return;
  window.yubzWishlistReady = true;
  const key = 'yubz-favourites-v1';
  const max = 100;
  let entries = [];
  let storageReadable = true;
  const rootURL = window.Shopify?.routes?.root || '/';
  const productURL = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/\/products\/[\w-]+$/.test(url.pathname)) return '';
      url.search = ''; url.hash = '';
      return `${rootURL.replace(/\/$/, '')}/products/${url.pathname.split('/products/').pop()}`;
    } catch { return ''; }
  };
  const imageURL = value => {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  };
  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(key) || '[]');
      storageReadable = true;
      const seen = new Set();
      entries = Array.isArray(raw) ? raw.filter(item => {
        if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string' || !productURL(item.url) || seen.has(String(item.id))) return false;
        seen.add(String(item.id)); return true;
      }).slice(0, max).map(item => ({id: String(item.id), title: item.title.slice(0, 300), url: productURL(item.url), image: imageURL(item.image)})) : [];
    } catch { entries = []; storageReadable = false; }
  }
  function message(text) {
    let status = document.querySelector('[data-yb-wishlist-status]');
    if (!status) {
      status = document.createElement('div'); status.className = 'yb-wishlist-toast'; status.dataset.ybWishlistStatus = '';
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); document.body.append(status);
    }
    status.textContent = text;
    clearTimeout(message.timer);
    message.timer = setTimeout(() => { status.textContent = ''; }, 5500);
  }
  function sync(root = document) {
    const buttons = [...root.querySelectorAll('[data-yb-wish]')];
    if (root.matches?.('[data-yb-wish]')) buttons.push(root);
    for (const button of buttons) {
      const saved = entries.some(item => item.id === button.dataset.ybWish);
      button.hidden = false; button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? button.dataset.removeLabel : button.dataset.saveLabel}: ${button.dataset.title || ''}`);
    }
    document.querySelectorAll('[data-yb-wishlist-count]').forEach(node => { node.textContent = String(entries.length); });
  }
  function render() {
    document.querySelectorAll('[data-yb-wishlist-page]').forEach(page => {
      const list = page.querySelector('[data-yb-wishlist-list]');
      const empty = page.querySelector('[data-yb-wishlist-empty]');
      if (!list || !empty) return;
      const active = document.activeElement;
      const focusedIndex = list.contains(active) ? [...list.querySelectorAll('button')].indexOf(active) : -1;
      list.replaceChildren(); empty.hidden = entries.length !== 0; list.hidden = entries.length === 0;
      for (const item of entries) {
        const card = document.createElement('li'); card.className = 'yb-wishlist-card';
        const link = document.createElement('a'); link.href = item.url;
        const media = document.createElement('div'); media.className = 'yb-wishlist-media';
        if (item.image) {
          const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 480; img.height = 480; img.loading = 'lazy'; media.append(img);
        }
        const title = document.createElement('h2'); title.textContent = item.title;
        link.append(media, title); card.append(link);
        const button = document.createElement('button'); button.type = 'button'; button.className = 'yb-wishlist-remove';
        Object.assign(button.dataset, {ybWish: item.id, title: item.title, url: item.url, image: item.image, saveLabel: page.dataset.saveLabel, removeLabel: page.dataset.removeLabel, savedMessage: page.dataset.savedMessage, removedMessage: page.dataset.removedMessage, errorMessage: page.dataset.errorMessage, limitMessage: page.dataset.limitMessage});
        button.textContent = page.dataset.removeLabel; button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', `${page.dataset.removeLabel}: ${item.title}`); card.append(button); list.append(card);
      }
      if (focusedIndex >= 0) {
        const buttons = list.querySelectorAll('button');
        const next = buttons[Math.min(focusedIndex, buttons.length - 1)] || empty.querySelector('a');
        next?.focus({preventScroll: true});
      }
    });
    sync();
  }
  function start() {
    read(); render();
    if (!storageReadable) {
      const page = document.querySelector('[data-yb-wishlist-page]');
      if (page) message(page.dataset.storageError);
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-yb-wish]'); if (!button) return;
      event.preventDefault(); event.stopPropagation();
      read();
      if (!storageReadable) { message(button.dataset.errorMessage); return; }
      const id = button.dataset.ybWish;
      const exists = entries.some(item => item.id === id);
      if (!exists && entries.length >= max) { message(button.dataset.limitMessage); return; }
      const url = productURL(button.dataset.url);
      if (!/^\d+$/.test(id) || !url) { message(button.dataset.errorMessage); return; }
      const next = exists ? entries.filter(item => item.id !== id) : [{id, title: (button.dataset.title || '').slice(0, 300), url, image: imageURL(button.dataset.image)}, ...entries];
      try { localStorage.setItem(key, JSON.stringify(next)); entries = next; }
      catch { message(button.dataset.errorMessage); return; }
      render(); message(exists ? button.dataset.removedMessage : button.dataset.savedMessage);
    });
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); render(); } });
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1 && (node.matches('[data-yb-wish]') || node.querySelector('[data-yb-wish]'))) sync(node);
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
